import { useEffect } from 'react';
import { TextZoom } from '@capacitor/text-zoom';
import { isNative } from '@/domains/shared/utils/native';

const MIN_ZOOM = 1.0; // Prevent scaling below default to avoid viewport zoom issues
const MAX_ZOOM = 1.5; // Cap scaling at 150% to prevent layout breakage

export function useTextZoom() {
  useEffect(() => {
    if (!isNative()) return;

    const applySystemZoom = async () => {
      try {
        const result = await TextZoom.getPreferred(); // Reads the system accessibility text size setting
        const clampedZoom = Math.max(
          MIN_ZOOM,
          Math.min(result.value, MAX_ZOOM),
        ); // Clamp between 1.0 and 1.5
        await TextZoom.set({ value: clampedZoom }); // Applies the zoom to the native WebView text zoom
      } catch (error) {
        console.error('Failed to apply text zoom:', error);
      }
    };

    applySystemZoom();

    const handleAppResume = () => {
      applySystemZoom();
    };

    document.addEventListener('resume', handleAppResume); // re-checks the system setting in case user changed it
    return () => document.removeEventListener('resume', handleAppResume);
  }, []);
}
